// extracted by mini-css-extract-plugin
export default {"formContainer":"AskForm_formContainer__mSScv","inputField":"AskForm_inputField__8wWdk","askButton":"AskForm_askButton__MFMOe"};